// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active {
  background-color: #f3f4f6;
}
.hover-group:hover .opacity-0 {
  opacity: 1 !important;
}
.custom-btn {
  height: 44px;
}


.chats-list-item {
  background-color: var(--bs-gray-200);
}


.chats-list-item:hover {
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.chats-list-item.active {
  background-color: var(--bs-primary);
  color: var(--bs-white);
  font-weight: 600;
}


.chat-list-item-container .chat-actions {
  transform: translateX(-100%);
  max-width: 0;
  overflow: hidden;
  transition: all 0.15s ease-in-out;
}

.chat-list-item-container:hover .chat-actions {
  max-width: 50px;
  transform: translateX(0);
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNpZGViYXIuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLHlCQUF5QjtBQUMzQjtBQUNBO0VBQ0UscUJBQXFCO0FBQ3ZCO0FBQ0E7RUFDRSxZQUFZO0FBQ2Q7OztBQUdBO0VBQ0Usb0NBQW9DO0FBQ3RDOzs7QUFHQTtFQUNFLHlDQUF5QztFQUN6Qyx3QkFBd0I7QUFDMUI7O0FBRUE7RUFDRSxtQ0FBbUM7RUFDbkMsc0JBQXNCO0VBQ3RCLGdCQUFnQjtBQUNsQjs7O0FBR0E7RUFDRSw0QkFBNEI7RUFDNUIsWUFBWTtFQUNaLGdCQUFnQjtFQUNoQixpQ0FBaUM7QUFDbkM7O0FBRUE7RUFDRSxlQUFlO0VBQ2Ysd0JBQXdCO0FBQzFCIiwiZmlsZSI6InNpZGViYXIuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5hY3RpdmUge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjNmNGY2O1xufVxuLmhvdmVyLWdyb3VwOmhvdmVyIC5vcGFjaXR5LTAge1xuICBvcGFjaXR5OiAxICFpbXBvcnRhbnQ7XG59XG4uY3VzdG9tLWJ0biB7XG4gIGhlaWdodDogNDRweDtcbn1cblxuXG4uY2hhdHMtbGlzdC1pdGVtIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tYnMtZ3JheS0yMDApO1xufVxuXG5cbi5jaGF0cy1saXN0LWl0ZW06aG92ZXIge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1icy1wcmltYXJ5LWxpZ2h0KTtcbiAgY29sb3I6IHZhcigtLWJzLXByaW1hcnkpO1xufVxuXG4uY2hhdHMtbGlzdC1pdGVtLmFjdGl2ZSB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWJzLXByaW1hcnkpO1xuICBjb2xvcjogdmFyKC0tYnMtd2hpdGUpO1xuICBmb250LXdlaWdodDogNjAwO1xufVxuXG5cbi5jaGF0LWxpc3QtaXRlbS1jb250YWluZXIgLmNoYXQtYWN0aW9ucyB7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtMTAwJSk7XG4gIG1heC13aWR0aDogMDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdHJhbnNpdGlvbjogYWxsIDAuMTVzIGVhc2UtaW4tb3V0O1xufVxuXG4uY2hhdC1saXN0LWl0ZW0tY29udGFpbmVyOmhvdmVyIC5jaGF0LWFjdGlvbnMge1xuICBtYXgtd2lkdGg6IDUwcHg7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgwKTtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/chat-with-ai/partials/sidebar/sidebar.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;;AAGA;EACE,oCAAoC;AACtC;;;AAGA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA,4+CAA4+C","sourcesContent":[".active {\n  background-color: #f3f4f6;\n}\n.hover-group:hover .opacity-0 {\n  opacity: 1 !important;\n}\n.custom-btn {\n  height: 44px;\n}\n\n\n.chats-list-item {\n  background-color: var(--bs-gray-200);\n}\n\n\n.chats-list-item:hover {\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n\n.chats-list-item.active {\n  background-color: var(--bs-primary);\n  color: var(--bs-white);\n  font-weight: 600;\n}\n\n\n.chat-list-item-container .chat-actions {\n  transform: translateX(-100%);\n  max-width: 0;\n  overflow: hidden;\n  transition: all 0.15s ease-in-out;\n}\n\n.chat-list-item-container:hover .chat-actions {\n  max-width: 50px;\n  transform: translateX(0);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
